export default {
  objetoPaginacao: {
    totalPages: null,
    currentPage: null,
    perPage: null,
    firstPage: null,
    lastPage: null,
    previousPage: null,
    nextPage: null,
    hasPreviousPage: false,
    hasNextPage: false,
    totalResults: null,
    results: null,
    firstResult: null,
    lastResult: null,
    data: [],
  },
};
